import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../style.css';
import '../nov.css';

const ArtistServices = () => {
  const services = [
    {
      title: 'Career Development',
      description: 'Strategic planning and guidance for long-term success',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="career" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="url(#career)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="url(#career)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      title: 'PR & Media',
      description: 'Strategic media campaigns to amplify your reach',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="pr" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" stroke="url(#pr)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      title: 'Content Creation',
      description: 'Professional videos and promotional materials',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="content" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="2.18" stroke="url(#content)" strokeWidth="1.2" />
          <path d="M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5" stroke="url(#content)" strokeWidth="1.2" />
        </svg>
      )
    },
    {
      title: 'Social Media',
      description: 'Expert management and growth strategies',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="social" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3V2z" stroke="url(#social)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      title: 'Playlisting',
      description: 'Get featured on top playlists and curators',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="playlist" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <path d="M9 18V5l12-1v13M9 10l12-1" stroke="url(#playlist)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="6" cy="18" r="3" stroke="url(#playlist)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="18" cy="17" r="3" stroke="url(#playlist)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      title: 'Marketing',
      description: 'Data-driven campaigns for maximum impact',
      icon: (
        <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="marketing" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(155, 207, 255)' }} />
              <stop offset="50%" style={{ stopColor: 'rgb(252, 212, 254)' }} />
              <stop offset="100%" style={{ stopColor: 'rgb(182, 241, 246)' }} />
            </linearGradient>
          </defs>
          <path d="M22 17H2a3 3 0 003 3h14a3 3 0 003-3zm0 0V5a3 3 0 00-3-3H5a3 3 0 00-3 3v12m18 0l-3.5-7-3.5 4-3.5-3-3.5 6" stroke="url(#marketing)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black py-20 lg:py-32 overflow-hidden">
        <div className="container mx-auto px-4 lg:px-0 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div 
              className="mb-8"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span 
                className="text-sm border bg-gradient-to-tr from-[#DBD0FD] via-[#FCD4FE] to-white text-black font-light py-2 px-4 rounded-full uppercase"
              >
                Artist Services
              </span>
            </motion.div>

            <motion.h1 
              className="text-4xl md:text-7xl lg:text-8xl font-bold mb-6 text-white"
              style={{ fontFamily: 'aesthet-nova' }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              ELEVATE YOUR<br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6]">
                MUSIC CAREER
              </span>
            </motion.h1>

            <motion.p 
              className="md:text-xl font-light max-w-[577px] m-auto text-gray-300"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Professional services to help artists succeed in the modern music industry
            </motion.p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-[#f2f2f2] py-20 lg:py-36 relative overflow-hidden">
        <div className="container mx-auto px-4 lg:px-0 relative z-10">
          <div className="w-full text-center mb-16">
            <motion.div 
              className="mb-10"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <span className="text-sm border bg-gradient-to-tr from-[#DBD0FD] via-[#FCD4FE] to-white text-black font-light py-2 px-4 rounded-full">
                What We Offer
              </span>
            </motion.div>

            <motion.h2 
              className="text-4xl md:text-7xl lg:text-8xl font-bold mb-6"
              style={{ color: 'rgb(70, 52, 135)', fontFamily: 'aesthet-nova' }}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              OUR SERVICES
            </motion.h2>

            <motion.p 
              className="md:text-xl font-light max-w-[577px] m-auto text-gray-600"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Comprehensive solutions for your artistic journey
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="group relative flex flex-col items-center justify-center rounded-2xl px-6 py-8 text-sm font-medium shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm transition-shadow duration-500 ease-out [--bg-size:300%] hover:shadow-[inset_0_-5px_10px_#8fdfff3f] bg-white text-center hover:scale-105 transition-transform duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
              >
                <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:var(--bg-size)_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                
                <div className="relative z-10 flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center justify-center mb-3 mt-2">
                    {service.icon}
                  </div>
                  <h3 
                    className="text-lg font-bold text-black mb-2 uppercase"
                    style={{ fontFamily: 'aesthet-nova' }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-xs">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-32 bg-gradient-to-br from-gray-900 to-black relative overflow-hidden">
        <div className="container mx-auto px-4 lg:px-0 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h2 
              className="text-4xl md:text-7xl font-bold mb-6 text-white"
              style={{ fontFamily: 'aesthet-nova' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              READY TO GROW?
            </motion.h2>

            <motion.p 
              className="md:text-xl font-light text-gray-300 mb-8 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Contact us to discuss how we can help you reach your goals
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Link
                to="/contact"
                className="group relative z-0 cursor-pointer items-center justify-center overflow-hidden whitespace-nowrap border border-white/10 px-8 py-4 text-white [background:var(--bg)] [border-radius:var(--radius)] transform-gpu transition-all duration-300 ease-in-out inline-block font-light rounded-full hover:scale-105 uppercase"
                style={{
                  '--spread': '90deg',
                  '--shimmer-color': '#000000',
                  '--radius': '100px',
                  '--speed': '3s',
                  '--cut': '0.2em',
                  '--bg': '#000000'
                }}
              >
                <div className="-z-30 blur-[2px] absolute inset-0 overflow-visible [container-type:size]">
                  <div className="absolute inset-0 h-[100cqh] animate-slide [aspect-ratio:1] [border-radius:0] [mask:none]">
                    <div className="animate-spin-around absolute inset-[-100%] w-auto rotate-0 [background:conic-gradient(from_calc(270deg-(var(--spread)*0.5)),transparent_0,var(--shimmer-color)_var(--spread),transparent_var(--spread))] [translate:0_0]"></div>
                  </div>
                </div>
                <span className="relative z-10">Get Started</span>
                <div className="insert-0 absolute h-full w-full rounded-2xl px-4 py-1.5 text-sm font-medium shadow-[inset_0_-8px_10px_#ffffff1f] transform-gpu transition-all duration-300 ease-in-out group-hover:shadow-[inset_0_-6px_10px_#ffffff3f]"></div>
                <div className="absolute -z-20 [background:var(--bg)] [border-radius:var(--radius)] [inset:var(--cut)]"></div>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default ArtistServices;
